import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { OUTCOME_COLORS } from './reportShared';
import { outcomeLabel } from '../outcomeApi';

export function InteractionList({ items, truncated }) {
  return (
    <Card className="overflow-hidden" data-testid="report-interactions">
      <div className="text-sm font-semibold p-4 pb-2">
        Logged interactions ({items.length}{truncated ? '+, showing latest 500' : ''})
      </div>
      <div className="divide-y max-h-[520px] overflow-y-auto">
        {items.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground">No interactions match these filters.</div>}
        {items.map(i => (
          <div key={i.outcome_id} className="px-4 py-2.5 text-sm flex items-start justify-between gap-3" data-testid={`report-item-${i.outcome_id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <Link to={`/admin/partners/${i.partner_id}`} className="font-medium hover:underline">{i.partner_name || i.partner_email || i.partner_id}</Link>
                <Badge variant="outline" className="text-xs" style={{ borderColor: OUTCOME_COLORS[i.outcome_type], color: OUTCOME_COLORS[i.outcome_type] }}>
                  {outcomeLabel(i.outcome_type)}{i.potential_referrals != null && ` · ${i.potential_referrals}`}
                </Badge>
              </div>
              {i.note && <div className="text-xs text-muted-foreground mt-0.5 truncate max-w-2xl" title={i.note}>"{i.note}"</div>}
            </div>
            <div className="text-xs text-muted-foreground text-right whitespace-nowrap">
              <div className="font-medium text-foreground">{i.logged_by_name}</div>
              {i.created_at && new Date(i.created_at).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
